try {
    require('./bootstrap')

    // Sempre
    Vue.component('flash', require('./components/Flash.vue').default)
    Vue.component('loader', require('./components/Loader.vue').default)
    Vue.component('main-menu', require('./components/MainMenu.vue').default)
    Vue.component('bottom-menu', require('./components/BottomMenu.vue').default)
    Vue.component('cookie-status', require('./components/CookieStatus.vue').default)
    Vue.component('multi-language', require('./components/MultiLanguage.vue').default)
    Vue.component('magazine-flipbook', require('./components/MagazineFlipbook.vue').default)

    // Molti componenti
    Vue.component('error-span', require('./components/ErrorSpan.vue').default)
    Vue.component('masked-image', require('./components/MaskedImage.vue').default)
    Vue.component('my-checkbox', require('./components/MyCheckbox.vue').default)
    Vue.component('my-input', require('./components/MyInput.vue').default)
    Vue.component('my-multiselect', require('./components/MyMultiselect.vue').default)
    Vue.component('my-textarea', require('./components/MyTextarea.vue').default)


    Vue.filter('capitalize', function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
    })

    window.events = new Vue()

    require('./helper-methods')

    require('./vue-init')
}
catch(error) {
    let overlay = document.getElementById('hide-overlay')

    if(overlay) {
        overlay.parentNode.removeChild(overlay)
    }
}
